export const IMAGE_COMPRESSION_QUALITY = 0.8;

export const IMAGE_COMPRESSION_MAX_SIZE = 2000;